import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './routes'
import "@/assets/css/styles.css";

// Import Global Styles
import '@mdi/font/css/materialdesignicons.css'; // Material Design Icons
import 'vuetify/styles'; // Vuetify Core Styles

const app=createApp(App)
app.use(router)
app.use(vuetify)
app.use(store)
app.mount('#app')
